// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dRqJ","content":"styles_content__yE67i","row":"styles_row__1QXKy","footer":"styles_footer__3ep5_","phraseLength":"styles_phraseLength__3OYtV"};